var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(" Workflow requires your attention as "),_c('b',[_vm._v(_vm._s(_vm.value.event.payload.workflow.assigned_to.toUpperCase()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }